export default "__VITE_ASSET__45607388__"